/**
 *
 * Asynchronously loads the component for FaqModule
 *
 */

import { lazyLoad } from 'utils/loadable';

export const FaqModule = lazyLoad(
  () => import('./index'),
  module => module.FaqModule,
);
